import { render, staticRenderFns } from "./generalPublicIncomeEdition.vue?vue&type=template&id=5ddef43f"
import script from "./generalPublicIncomeEdition.vue?vue&type=script&lang=js"
export * from "./generalPublicIncomeEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports